export class ApiError {
  code: number;
  text: string;

  constructor(code:number, text: string) {
    this.code = code;
    this.text = text;
  }
}
